module.exports = __webpack_public_path__ + "img/Search.c5a14936.svg";